import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Async from 'react-select';
//components
import Field from '../../Common/Field/Field'
import Button from '../../Buttons/Button'

//services
import { DevelopmentServices } from '../../../services'

export default class Embroidery extends Component {
    state = {
        sourcingOptions: [],
        sourcingValue: null,
        embroidery: {},
    }

    componentWillMount() {
        const { actionedByOption, fabricInfo, embroideryInfo, embroidery, sourcingInfo } = this.props



        this.setState({
            actionedByOption, fabricInfo, embroideryInfo, embroidery, sourcingInfo,
            sourcingValue: embroidery.sourcing
        })


        DevelopmentServices.getSourcingInfo('').then((response) => {
            if (response.status === 200) {
                this.setState({
                    sourcingOptions: response.text.data
                })
            }
        }).catch((error) => {

        })
    }
    componentDidMount() {
        if (this.props.scroll) {
            var embroideryEle = document.getElementById('embroideryId')
            embroideryEle.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        }
    }

    componentWillReceiveProps(nextProps) {
        const { actionedByOption, fabricInfo, embroideryInfo, fabric, sourcingInfo } = nextProps
        this.setState({
            actionedByOption, fabricInfo, embroideryInfo, fabric, sourcingInfo
        })
    }

    //sourcing info
    getSourcingInfo = (e) => {
        if (e.length > 0) {
            DevelopmentServices.getSourcingInfo(e).then((response) => {
                if (response.status === 200) {
                    this.setState({
                        sourcingOptions: response.text.data
                    })
                }
            }).catch((error) => {

            })
        }
    }

    changeSourcingInfo = (sourcingValue) => {
        sourcingValue !== null && this.setState({ sourcingValue }, this.props.getSourcingData(sourcingValue.value));
    }

    updateValue = (name, value) => {
        this.props.getEmbroidery('embroidery', name, value)
    }

    createEmbroidery = (e) => {
        e.preventDefault()
        let embroidery = { ...this.props.embroidery }
        Object.keys(embroidery).forEach((x) => {
            if (embroidery[x] === "" || embroidery[x] == false)
                delete embroidery[x]
        })
        embroidery._id = this.props._id
        embroidery.actionedBy = null

        let data = {
            embroidery: embroidery,
            _id: this.props._id,
            toggle: { ...this.props.toggle },
        }
        DevelopmentServices.createEmbroidery(data).then(response => {
            if (response.status === 200) {

                this.props.getalertMessage('success', ' Embroidery Created ')
            }
            response.status === 401 && this.props.unauthorizedFunc()
        })
    }


    render() {

        const { getEmbroidery, embroidery, disabled, designDescriptionOptions } = this.props

        const { actionedByOption, fabricInfo, embroideryInfo, sourcingValue, sourcingOptions } = this.state



        return (
            <div className="col-md-12 px-5" id='embroideryId' >
                <h6 className="text-green font-lg font-weight-bold"><b>Embroidery</b></h6>
                <div className="col-md-12 product-form px-0">
                    <div className="row px-3">
                        <div className="col-md-2">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='actionedBy'
                                value={fabricInfo && fabricInfo.EMBROIDERY && fabricInfo.EMBROIDERY.ASSIGNEDTO && fabricInfo.EMBROIDERY.ASSIGNEDTO.length > 0 && fabricInfo.EMBROIDERY.ASSIGNEDTO[0].value}
                                options={fabricInfo.EMBROIDERY && fabricInfo.EMBROIDERY.ASSIGNEDTO ? fabricInfo.EMBROIDERY.ASSIGNEDTO : []}
                                label='Assigned To'
                                onChange={this.updateValue}
                                disabled={true}
                            />
                        </div>
                        <div className="col-md-2">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='fabricBase'
                                value={embroidery.fabricBase}
                                options={fabricInfo.BASICQUALITY}
                                label='Basic Quality'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-2">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='threadQuality'
                                value={embroidery.threadQuality}
                                options={fabricInfo.THREADQUALITY || []}
                                label='Thread Quality'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-2">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='machineType'
                                value={embroidery.machineType}
                                options={fabricInfo.MACHINETYPE}
                                label='Machine type'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>

                        <div className="col-md-2">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='designDescription'
                                value={embroidery.designDescription}
                                options={fabricInfo.DESIGNDESCRIPTION}
                                label='Design Description'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-3">
                            <Field
                                isFormGroup={true}
                                inputType='text'
                                inputName='targetRate'
                                value={embroidery.targetRate}
                                label='Target rate including fabric'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>

                        <div className="col-md-2">
                            <Field
                                isFormGroup={true}
                                inputType='select'
                                inputName='embTechinique'
                                value={embroidery.embTechinique}
                                options={fabricInfo.EMBTECHNIQUE}
                                label='Emb Technique'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-2">
                            <Field
                                isFormGroup={true}
                                inputType='text'
                                inputName='backingDetails'
                                value={embroidery.backingDetails}
                                label='Backing Details'
                                onChange={this.updateValue}
                                disabled={disabled}
                            />
                        </div>
                        <div className="col-md-12 nopadding">
                            <div className="col-md-2">
                                <Field
                                    isFormGroup={true}
                                    inputType='checkboxToggle'
                                    inputName='backing'
                                    value={embroidery.backing}
                                    label='Backing'
                                    value={embroidery.backing}
                                    onChange={this.updateValue}
                                    disabled={disabled}
                                />
                            </div>
                            <div className="col-md-2">
                                <Field
                                    isFormGroup={true}
                                    inputType='checkboxToggle'
                                    inputName='gradingRequired'
                                    label='Grading reqd'
                                    value={embroidery.gradingRequired}
                                    onChange={this.updateValue}
                                    disabled={disabled}
                                />
                            </div>
                            <div className="col-md-2">
                                <Field
                                    isFormGroup={true}
                                    inputType='checkboxToggle'
                                    inputName='marker'
                                    label='Marker'
                                    value={embroidery.marker}
                                    onChange={this.updateValue}
                                    disabled={disabled}
                                />
                            </div>
                            <div className="col-md-2">
                                <Field
                                    isFormGroup={true}
                                    inputType='checkboxToggle'
                                    inputName='scalloping'
                                    label='Scalloping'
                                    value={embroidery.scalloping}
                                    onChange={this.updateValue}
                                    disabled={disabled}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 profile-btn text-center">
                            <Button
                                buttonName='Save'
                                onClick={this.createEmbroidery}
                            />
                            <Button
                                buttonName='Cancel'
                                buttonType='cancel'
                                history={this.props.history}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Embroidery.propTypes = {

};

Embroidery.defaultProps = {

}


// WEBPACK FOOTER //
// ./src/components/Fabric/Embroidery/Embroidery.js